"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionMenu = void 0;
const react_1 = __importStar(require("react"));
const useOnOutsideClick_1 = require("../../../../Hooks/useOnOutsideClick");
const Typography_1 = __importStar(require("../../../UI/Typography"));
const style = __importStar(require("./styled"));
const BurgerClosed_1 = require("../../../../assets/svg-components/BurgerClosed");
const Pill_1 = __importDefault(require("../../../UI/Pill"));
const Modal_1 = __importDefault(require("../../../UI/Modal"));
const Theme_1 = require("../../../../Theme");
const useTranslate_1 = require("../../../../Hooks/useTranslate");
const Utils_1 = require("../../../../Utils");
const Constants_1 = require("../../../../Constants");
const spa_core_1 = require("@episerver/spa-core");
const RegionMenu = ({ setIsRegionOpen, regions, activeRegion, linkedSite }) => {
    var _a, _b, _c, _d, _e;
    const { t } = (0, useTranslate_1.useTranslate)();
    const cmsState = (0, spa_core_1.useCmsState)();
    const wrapperRef = (0, react_1.useRef)(null);
    const closeButtonRef = (0, react_1.useRef)(null);
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, () => setIsRegionOpen(false));
    const lastRegion = regions.length;
    const closeRegionMenu = () => {
        setIsRegionOpen(false);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = closeButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const setCookies = (href) => {
        const path = href.replace(/^(https?:\/\/)?(www\.)?/i, '');
        const pathArr = path.split('/');
        const lang = pathArr[1];
        let continent = pathArr[2];
        if (Constants_1.NORTH_AMERICA.includes(continent)) {
            continent = Constants_1.NORTH_AMERICA[0];
        }
        else if (Constants_1.EUROPE.includes(continent)) {
            continent = Constants_1.EUROPE[0];
        }
        if (lang) {
            (0, Utils_1.setCookie)(Constants_1.LANGUAGE_COOKIE, lang, 365);
        }
        if (continent) {
            (0, Utils_1.setCookie)(Constants_1.CONTINENT_COOKIE, continent.toUpperCase(), 365);
        }
    };
    const iContent = cmsState === null || cmsState === void 0 ? void 0 : cmsState.iContent;
    // Map from original link to alternative link
    const getAlternateLink = (original) => {
        var _a, _b;
        const link = (_a = iContent === null || iContent === void 0 ? void 0 : iContent.alternativeLinks) === null || _a === void 0 ? void 0 : _a.find(al => al.url.startsWith(original));
        return (_b = link === null || link === void 0 ? void 0 : link.url) !== null && _b !== void 0 ? _b : original;
    };
    return (react_1.default.createElement(Modal_1.default, null,
        react_1.default.createElement(style.RegionContainer, { ref: wrapperRef },
            react_1.default.createElement(style.HeadingRow, null,
                react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.INTRODUCTORY_TEXT }, t('/haldex/region_menu/intoductory_text'))),
            react_1.default.createElement(style.Row, null,
                react_1.default.createElement(style.CountryCol, { md: 9, sm: 12 },
                    react_1.default.createElement(style.Row, null,
                        regions.map((region, i) => {
                            var _a;
                            if (i !== 3 && region.header && ((_a = region.links) === null || _a === void 0 ? void 0 : _a.length)) {
                                return (react_1.default.createElement(style.Col, { md: 4, sm: 6, xs: 6, key: i },
                                    react_1.default.createElement(style.ColumnTitle, { type: Typography_1.Types.EYEBROW }, region.header),
                                    region.links.map((link, x) => {
                                        var _a, _b;
                                        return (react_1.default.createElement(Pill_1.default, { key: x, label: link.text, isActive: (activeRegion === null || activeRegion === void 0 ? void 0 : activeRegion.toLowerCase()) ===
                                                `${(_a = region.header) === null || _a === void 0 ? void 0 : _a.toLowerCase()} - ${(_b = link.text) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`, width: Theme_1.theme.constants.pillWidth.sm, href: getAlternateLink(link.href), forceReload: true, onClick: () => setCookies(link.href) }));
                                    })));
                            }
                            else {
                                return null;
                            }
                        }),
                        react_1.default.createElement(style.Col, { md: 4, sm: 6, xs: 6 },
                            react_1.default.createElement(style.ColumnTitle, { type: Typography_1.Types.EYEBROW }, regions[lastRegion - 1].header),
                            ((_a = regions[lastRegion - 1].links) === null || _a === void 0 ? void 0 : _a.length) &&
                                regions[lastRegion - 1].header &&
                                regions[lastRegion - 1].links.map((link, i) => {
                                    var _a, _b;
                                    return (react_1.default.createElement(Pill_1.default, { key: i, label: link.text, isActive: (activeRegion === null || activeRegion === void 0 ? void 0 : activeRegion.toLowerCase()) ===
                                            `${(_a = regions[lastRegion - 1].header) === null || _a === void 0 ? void 0 : _a.toLowerCase()} - ${(_b = link.text) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`, width: Theme_1.theme.constants.pillWidth.sm, href: link.href, forceReload: true }));
                                })))),
                react_1.default.createElement(style.CorporateCol, { md: 3, sm: 12 }, ((_b = linkedSite === null || linkedSite === void 0 ? void 0 : linkedSite.link) === null || _b === void 0 ? void 0 : _b.text) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(style.ColumnTitle, { type: Typography_1.Types.EYEBROW }, linkedSite.link.text),
                    react_1.default.createElement(Pill_1.default, { label: (_c = linkedSite.link) === null || _c === void 0 ? void 0 : _c.title, width: Theme_1.theme.constants.pillWidth.sm, href: (_d = linkedSite.link) === null || _d === void 0 ? void 0 : _d.href, forceReload: false, target: (_e = linkedSite.link) === null || _e === void 0 ? void 0 : _e.target }))))),
            react_1.default.createElement(style.IconContainer, { ref: closeButtonRef, type: "button", "aria-label": t('/haldex/attributes/aria-label/close'), onClick: closeRegionMenu },
                react_1.default.createElement(BurgerClosed_1.BurgerClosedIcon, null)))));
};
exports.RegionMenu = RegionMenu;
exports.default = exports.RegionMenu;
